<template>
    <div id="backhead">
        <img class="logo" src="../assets/back/backLog.png" alt="Logo" />
        <div class="quit">
            <div @click="toIndex">[返回首页]</div>
            <div v-if="type == 2" @click="dialogFormVisible = true">[修改密码]</div>
            <el-dialog width="30%" title="修改密码" style="text-align: center" :visible.sync="dialogFormVisible">
                <el-form :model="form">
                    <el-form-item label="原密码:" :label-width="formLabelWidth">
                        <el-input v-model="form.password" type="password" placeholder="请输入原密码"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码:" :label-width="formLabelWidth">
                        <el-input placeholder="请输入新密码密码" type="password" v-model="form.password1"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码:" :label-width="formLabelWidth">
                        <el-input placeholder="请输入新密码密码" type="password" v-model="form.password2"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="changpswd">确 定</el-button>
                </div>
            </el-dialog>
            <div style="color:#FF284B;margin-left:0.2rem;" @click="toindex">[退出]</div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
export default {
    name: "backnav",
    inject: ["reload"],
    props: ["ms", "ims"],

    type: "",
    data() {
        return {
            form: {
                password: "",
                password1: "",
                password2: "",
            },
            dialogFormVisible: false,

            formLabelWidth: "100px",
        };
    },
    created() {
        this.type = sessionStorage.getItem("type");
    },
    mounted() {},
    methods: {
        //   wat_fun(val){ // 这里可以调用搜索api接口
        //   console.log(val)
        //  },

        toindex() {
            this.$confirm("是否退出当前账号?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let that = this;
                    this.$axios.post("login/logout?token=" + sessionStorage.getItem("token")).then((res) => {
                        if (res.data.code == 10000) {
                            Vue.prototype.$uName = "";
                            // sessionStorage.clear();
                            sessionStorage.removeItem("name");
                            sessionStorage.removeItem("token");
                            sessionStorage.removeItem("userinfo");
                            sessionStorage.removeItem("scroll");
                            that.$message({
                                type: "success",
                                message: "退出成功!",
                            });
                            that.$router.push("/");
                            that.reload();
                        } else {
                            Vue.prototype.$uName = "";
                            // sessionStorage.clear();
                            sessionStorage.removeItem("name");
                            sessionStorage.removeItem("token");
                            sessionStorage.removeItem("userinfo");
                            sessionStorage.removeItem("scroll");
                            that.$message({
                                type: "success",
                                message: "退出成功!",
                            });
                            that.$router.push("/");
                            that.reload();
                        }
                    });
                })
                .catch(() => {});
        },
        toIndex() {
            // this.reload();
            this.$router.push({
                path: "/",
            });
        },
        changpswd() {
            let that = this;
            for (var key in this.form) {
                if (!this.form[key]) {
                    this.$message({
                        message: "信息填写不完整,请重新输入",
                        type: "warning",
                    });
                    return;
                }
            }
            const regex = /^.*(?=.{8,16})(?=.*\d)(?=.*[A-Z]{1,})(?=.*[a-z]{1,})(?=.*[!@#$%_^&*.?\\(\\)])(?!.*?[^\S*]).*$/;

            if (!regex.test(this.form.password1)) {
                this.$message({
                    message: "密码要求：长度为8-16个字符，必须包含大小写字母、数字、特殊符号（!@#$%_^&*.?不包括空格）",
                    type: "warning",
                });
                return;
            }
            if (this.form.password1 != this.form.password2) {
                this.$message({
                    message: "两次输入密码不一致",
                    type: "warning",
                });
                return;
            }
            that.$axios
                .post("welcome/setpwd?token=" + sessionStorage.getItem("token"), that.$qs.stringify(that.form))
                .then((res) => {
                    if (res.data.code == 10000) {
                        that.$message({ message: "修改成功", type: "success" });
                        that.dialogFormVisible = false;
                        that.$axios.post("login/logout?token=" + sessionStorage.getItem("token")).then((res) => {
                            if (res.data.code == 10000) {
                                sessionStorage.clear();
                                that.$message(res.data.msg);
                                that.$router.replace("/");
                                location.reload();

                                // that.isLogin=true
                            } else {
                                that.$message(res.data.msg);
                            }
                        });
                        //   location.reload()
                        //   for(var key in that.form){
                        //       console.log(that.form[key])
                        //   }
                    } else {
                        that.$message(res.data.msg);
                    }
                });
        },
    },
};
</script>
<style scoped lang="less">
#backhead {
    position: relative;
    height: 1.49rem;
    width: 100%;
    background: url("../assets/back/103.png") center center no-repeat;
    .logo {
        position: relative;
        width: 6.6rem;
        left: 2.51rem;
        top: 0.35rem;
        display: block;
    }
    .quit {
        position: absolute;
        top: 0.91rem;
        right: 2.5rem;
        display: flex;
        cursor: pointer;
        div {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(65, 128, 254, 1);
        }
    }
}
</style>
